import React, { useEffect } from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { Experiment } from '../../types/Experiment';
import { DH } from '../../utils/dataHooks';
import { PaymentMethodsList } from '../PaymentMethodsList';
import {
  selectAreResourcesLoaded,
  selectCurrency,
  selectIsPayPalPmAvailable,
  selectPayPalBnCode,
  selectPayPalClientId,
  selectPayPalMerchantId,
} from '../../selectors';
import { useDispatch, useSelector } from '../../store';
import { loadPayPalScript } from '../../actions/loadPayPalScript';
import { useFedopsLogger } from '../Provider/Fedops/FedopsProvider';

export const ResourcesLoader = () => {
  const isPayPalPmAvailable = useSelector(selectIsPayPalPmAvailable);
  const clientId = useSelector(selectPayPalClientId);
  const merchantId = useSelector(selectPayPalMerchantId);
  const bnCode = useSelector(selectPayPalBnCode);
  const currency = useSelector(selectCurrency);
  const areResourcesLoaded = useSelector(selectAreResourcesLoaded);
  const dispatch = useDispatch();
  const fedopsLogger = useFedopsLogger();
  const { experiments } = useExperiments();

  useEffect(() => {
    if (isPayPalPmAvailable) {
      dispatch(
        loadPayPalScript({
          bnCode,
          clientId,
          currency,
          merchantId,
          testBuyerCountry: experiments.enabled(Experiment.EnablePPCreditAndVenmoTest),
          fedopsLogger,
        }),
      );
    }
  }, [dispatch, isPayPalPmAvailable, bnCode, clientId, currency, merchantId, experiments, fedopsLogger]);

  return <div data-hook={DH.Widget.ResourceLoader}>{areResourcesLoaded ? <PaymentMethodsList /> : null}</div>;
};
